var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"vtd-main-section",style:({
    backgroundImage:
      'url(https://cdn.trailfinders.com/hy50gj7p6n_bg-viewtrail.jpg)',
  }),attrs:{"role":"main"}},[_c('article',{staticClass:"vtd-section-info"},[_vm._t("default")],2),_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }